<template>
  <div>
    <sticky>
      <tabs v-model="active">
        <tab title="可使用" />
        <tab title="不可用" />
      </tabs>
    </sticky>
    <pull-refresh v-model="pullLoading" @refresh="refreshList">
      <list v-model="loading" :finished="!hasNext" finished-text="没有更多了" @load="loadList" :immediate-check="false">
        <div style="text-align: center; padding: 10vh 0" v-if="listInfo.length == 0 && !loading"></div>
        <div class="finance-list">
          <div class="finance-item" v-for="(item, index) in listInfo" :key="index">
            <div class="finance-content">
              <div class="finance-info">
                <h3 class="finance-name">{{ item.pointsBalance }}</h3>
                <p class="finance-tip">初始积分：{{ item.originalPoints }}</p>
                <p class="finance-tip">生效日期：{{ item.effectiveDate }}</p>
                <p class="finance-tip">到期日期：{{ item.expirationDate }}</p>
                <p class="finance-tip">卡类型：{{ userPointsTypeAll.getValueByKey(item.pointsType) }}</p>
                <p class="finance-tip">卡号：{{ item.cardNumber }}</p>
              </div>
              <div class="finance-status">
                <p class="view-details">{{ userPointsStatusAll.getValueByKey(item.status) }}</p>
              </div>
            </div>
          </div>
        </div>
      </list>
    </pull-refresh>
  </div>
</template>

<script>
import { PullRefresh, List, Tab, Tabs, Sticky } from 'vant';
import services from '@/service';
import { userPointsStatusAll, userPointsTypeAll } from '@/enum/index';

export default {
  components: { PullRefresh, List, Tab, Tabs, Sticky },
  data() {
    return {
      items: [],
      pullLoading: false,
      loading: false,
      hasNext: true,
      queryParams: {
        pageNum: 0,
        pageSize: 10
      },
      listInfo: [],
      effective: true,
      active: 0,
      userPointsStatusAll,
      userPointsTypeAll
    };
  },
  watch: {
    active: {
      handler: function() {
        this.effective = !this.active;
        this.refreshList();
      },
      immediate: true
    }
  },
  methods: {
    pointsBalance(item) {
      return (item.originalPoints - item.pointsBalance).toFixed(0);
    },
    async refreshList() {
      this.pullLoading = true;
      this.listInfo = [];
      this.queryParams.pageNum = 0;
      this.hasNext = false;
      setTimeout(() => {
        this.loadList();
      }, 500);
    },
    async loadList() {
      this.queryParams.pageNum++;

      const res = await services.mall.userPointsCardList({ effective: this.effective });
      this.listInfo = [...this.listInfo, ...res.rows];
      this.hasNext = this.listInfo.length < res.total;
      this.pullLoading = false;
      this.loading = false;
    },
    toDetail(item) {
      this.$router.push({
        name: 'partnerFinanceDetail',
        query: {
          billId: item.billId
        }
      });
    }
    // withdrawal(id) {}
  },
  mounted() {
    // this.refreshList();
  }
};
</script>

<style lang="scss" scoped>
.finance-item {
  background: linear-gradient(to right bottom, #fff, #fafafa);
  padding: 20px;
  margin: $tb $lr;
  border-radius: $radius;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
  }
}

.finance-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.finance-info {
  flex: 1;
  padding-right: 20px;
}

.finance-name {
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 700;
  color: $appcolor;
  background: linear-gradient(45deg, $appcolor, lighten($appcolor, 20%));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.finance-tip {
  color: $gray2;
  font-size: 14px;
  margin-top: 10px;
  display: flex;
  align-items: center;

  &:before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    background: $appcolor;
    border-radius: 50%;
    margin-right: 8px;
    opacity: 0.6;
  }

  .finance-amount {
    color: $red1;
    font-size: 16px;
    font-weight: 600;
  }
}

.finance-status {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 8px 12px;
  background: rgba($appcolor, 0.1);
  border-radius: 20px;
}

.view-details {
  font-size: 14px;
  font-weight: 500;
  color: $appcolor;
  padding: 4px 0;
}
</style>
